import React, { Component } from 'react';
import './App.scss';
import { Switch, Route, withRouter } from 'react-router-dom';
import { DashboardComponent, AllMessagesComponent } from './dashboard';
import { ResponsesComponent, ViewResponsesComponent } from './responses';
import { EventListComponent } from './events';
import { AccountInfoComponent } from './acct';
import { features, featureHelpers, HiddenFeature } from './features';
import { integrationTypes } from './tenantInfo';
import AppContent from "./app-content";
import MyScheduleComponent from './scheduler/mySchedule/mySchedule.component';
import AppointmentDetailsComponent from './scheduler/appointmentDetails/appointmentDetails.component';

/** All the pages in the Application that should display the privacy links */
class App extends Component {

  render() {
    const routes = (
      <Switch>
        <Route exact path="/" component={DashboardComponent} />
        <Route exact path="/messages" component={featureHelpers.meetsFeatureRequirements([features.apricotPortalDashboardMessages], [integrationTypes.apricot]) ? AllMessagesComponent : HiddenFeature} />
        <Route exact path="/accountinfo" component={AccountInfoComponent} />
        <Route
          exact path="/responses"
          component={featureHelpers.meetsFeatureRequirements([features.apricotPortalTier2], [integrationTypes.apricot]) ? ResponsesComponent : HiddenFeature} />
        <Route exact path="/responses/list" component={featureHelpers.meetsFeatureRequirements([features.apricotPortalTier2]) ? ViewResponsesComponent : HiddenFeature} />
        <Route exact path="/events" component={EventListComponent} />
        <Route exact path="/appointments" component={featureHelpers.meetsFeatureRequirements([features.connectScheduler], [integrationTypes.apricot]) ? MyScheduleComponent : HiddenFeature} />
        <Route path="/appointments/details" component={featureHelpers.meetsFeatureRequirements([features.connectScheduler], [integrationTypes.apricot]) ? AppointmentDetailsComponent : HiddenFeature} />
      </Switch>
    );
    return (
      <AppContent hidePrivacyLinks={false} routes={routes}/>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// src/App.js